var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlusDown = function SvgPlusDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
    fill: "#8B90A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16L6 20L3 16H9Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlusDown);
export { ForwardRef as ReactComponent };